export const error = {
  error404Title: "404",
  error404Description: "OOPS! Something went wrong...",
  error: "Error",
  accessDenied: "Access Denied",
  noPermissions: "No permissions"
};
